import { NgModule, ModuleWithProviders  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'angular-calendar';

import { CoreMaterialModule } from '../core/core.material.module';
import { ReportSectionComponent } from './report.section.component';
import { HeaderComponent } from './header.component';
import { ListActionsComponent } from './list.actions.component';
import { DetailActionsComponent } from './detail.actions.component';
import { DownloadFileComponent } from './download.file.component';
import { UploadFileComponent } from './upload.file.component';
import { MenuComponent } from './menu.component';
import { MenuItemComponent } from './menu.item.component';
import { CalendarComponent } from './calendar.component';
import { AddCalendarEventComponent } from './add.calendar.event.component';
import { SectionHeaderComponent } from './section.header.component';
import { DetailAuditComponent } from './detail.audit.component';
import { ListSectionHeaderComponent } from './list.section.header.component';
import { ConfirmationDialogComponent } from './confirmation.dialog.component';
import { NumberToWordsPipe } from './number.to.words.pipe';
import { AmountWithCommasPipe } from './amount.with.commas.pipe';
import { ReportActionsComponent} from './report.actions.component';
import { ConfirmationDueDialogComponent } from './confirmation.due.dialog.component';

import {ConfirmationLoginDialogComponent} from './confirmation.login.dialog.component';
@NgModule({
  declarations: [
    HeaderComponent,
    ListActionsComponent,
    DetailActionsComponent,
    DownloadFileComponent,
    UploadFileComponent,
    MenuComponent,
    MenuItemComponent,
    CalendarComponent,
    AddCalendarEventComponent,
    SectionHeaderComponent,
    DetailAuditComponent,
    ListSectionHeaderComponent,
    ConfirmationDialogComponent,
    NumberToWordsPipe,
    AmountWithCommasPipe,
     ReportSectionComponent,
    ReportActionsComponent,
    ConfirmationDueDialogComponent,
    ConfirmationLoginDialogComponent
  ],
  entryComponents: [
    AddCalendarEventComponent,
    ConfirmationDialogComponent,
    ConfirmationDueDialogComponent,
    ConfirmationLoginDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    CalendarModule,
    CoreMaterialModule
  ],
  exports: [
    TranslateModule,
    HeaderComponent,
    ListActionsComponent,
    DetailActionsComponent,
    DownloadFileComponent,
    UploadFileComponent,
    MenuComponent,
    CalendarComponent,
    SectionHeaderComponent,
    DetailAuditComponent,
    ListSectionHeaderComponent,
    ConfirmationDialogComponent,
    NumberToWordsPipe,
    AmountWithCommasPipe,
     ReportSectionComponent,
    ReportActionsComponent,
    ConfirmationDueDialogComponent
  ],
  providers: [
    AmountWithCommasPipe,
    NumberToWordsPipe
  ],
})
export class CommonComponentModule {

}
